import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { Section } from "./section";

export interface UnitRow {
  id: string;
  label: string;
  use: string;
  configuration: string | null;
  grossFloorArea: number | null;
  includedInEstimate: boolean;
}

function area(v: number | null): string {
  if (v == null) return "—";
  return `${v.toLocaleString("en-NZ", { minimumFractionDigits: 0, maximumFractionDigits: 1 })} m²`;
}

export function SectionUnits({ units }: { units: UnitRow[] }): React.ReactElement | null {
  if (units.length === 0) return null;

  return (
    <Section id="units" title="Residential Unit Schedule">
      <p className="text-xs text-muted-foreground mb-3">
        ANZVGP 104 A1.2: gross floor area stated for each residential unit. Natural Hazards Insurance Act 2023 cover is
        per dwelling.
      </p>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Unit</TableHead>
              <TableHead>Use</TableHead>
              <TableHead>Configuration</TableHead>
              <TableHead className="text-right">Gross Floor Area</TableHead>
              <TableHead>Included in Estimate</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {units.map((row) => (
              <TableRow key={row.id}>
                <TableCell className="font-medium">{row.label}</TableCell>
                <TableCell>{row.use}</TableCell>
                <TableCell>{row.configuration ?? "—"}</TableCell>
                <TableCell className="text-right tabular-nums">{area(row.grossFloorArea)}</TableCell>
                <TableCell>{row.includedInEstimate ? "Yes" : "No"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Section>
  );
}
